import {
  AlertDialog as AxiomAlertDialog,
  AlertDialogAction as AxiomAlertDialogAction,
  AlertDialogBody as AxiomAlertDialogBody,
  AlertDialogCancel as AxiomAlertDialogCancel,
  AlertDialogContent as AxiomAlertDialogContent,
  AlertDialogFooter as AxiomAlertDialogFooter,
  AlertDialogHeader as AxiomAlertDialogHeader,
  Box,
  Flex,
} from '@optiaxiom/react';
import { IconTriangleExclamation } from '@optimizely/axiom-icons';

type ConfirmationModalProps = {
  title: string;
  children: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  cancelLabel?: string;
  action?: string;
  actionDisabled?: boolean;
  confirmLoading?: boolean;
  isShown?: boolean;
  appearance?: 'primary' | 'permission' | 'danger';
  cancelDisabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

export function ConfirmationModal({ ...props }: ConfirmationModalProps) {
  const {
    title,
    children,
    onCancel,
    onConfirm,
    cancelLabel = 'Cancel',
    action,
    actionDisabled,
    confirmLoading,
    isShown,
    appearance = 'primary',
    cancelDisabled,
    size = 'sm',
  } = props;

  const buttonAppearance = appearance === 'permission' ? 'primary' : appearance;

  const alertIcon = appearance === 'permission' ? 'lock-outline' : undefined;

  return (
    <AxiomAlertDialog open={isShown}>
      <AxiomAlertDialogContent onEscapeKeyDown={onCancel} size={size}>
        <AxiomAlertDialogHeader
          {...(alertIcon && {
            addonBefore: (
              <Flex>
                <Box asChild color="fg.secondary" h="16" w="auto">
                  <IconTriangleExclamation />
                </Box>
              </Flex>
            ),
          })}
        >
          {title}
        </AxiomAlertDialogHeader>
        <AxiomAlertDialogBody>{children}</AxiomAlertDialogBody>
        <AxiomAlertDialogFooter>
          <AxiomAlertDialogCancel disabled={cancelDisabled} onClick={onCancel}>
            {cancelLabel}
          </AxiomAlertDialogCancel>
          <AxiomAlertDialogAction
            appearance={buttonAppearance}
            disabled={actionDisabled}
            loading={confirmLoading}
            onClick={onConfirm}
          >
            {action}
          </AxiomAlertDialogAction>
        </AxiomAlertDialogFooter>
      </AxiomAlertDialogContent>
    </AxiomAlertDialog>
  );
}
